export default __webpack_public_path__ + "static/media/companyLogo4.3ff233fe.png";